import { useEffect, useState } from 'react';
import { fetchEventCountsPerObjectType } from '../../../kpi/CountsTiles/api/countsApi';

/**
 * Hook to fetch total number of events per object type.
 * Returns { data: Record<string, number> | null, loading: boolean, error: string | null, refresh: (fileType?: string|null)=>Promise<void> }
 */
export const useEventCountsPerObjectType = (activeFile = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async (fileType) => {
    setLoading(true);
    setError(null);
    try {
      const effectiveFileType = fileType ?? activeFile ?? null;
      const res = await fetchEventCountsPerObjectType(effectiveFileType);
      setData(res?.eventCountsPerObjectType || {});
    } catch (e) {
      setError(e?.message || 'Failed to load events per object type');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const effectiveFileType = activeFile ?? null;
        const res = await fetchEventCountsPerObjectType(effectiveFileType);
        if (!cancelled) setData(res?.eventCountsPerObjectType || {});
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Failed to load events per object type');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [activeFile]);

  return { data, loading, error, refresh: load };
};
